export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'PORTFOLIO': {
                'TITULO': 'Portfolio'
            },
            'DASHBOARD': {
                'TITULO': 'General Dashboard'
            },
            'DOCUMENTOS': {
                'TITULO': 'Documents'
            },
            'TICKETS': {
                'TITULO': 'Tickets'
            },
            'GESTION': 'Manage',
            'ACTIVOS': {
                'TITULO': 'Assets'
            },
            'CLIENTES': {
                'TITULO': 'Clients'
            },
            'USUARIOS': {
                'TITULO': 'Users'
            },
          'SOCIEDADES': {
            'TITULO': 'Companies'
          }
        },
        'PANEL': {
            'TITULO': 'Assets',
            'BUSCAR': 'Search',
            'DETALLE': {
                'DASHBOARD': 'Dashboard',
                'DOCUMENTOS': 'Documents',
                '3DVIEWER': '3D viewer',
                'REVIEW': 'Review'
            }
        },
        'DASHBOARD': {
            'TITULO': 'Project Dashboard',
            'WIDGET1': {
                'TITULO': 'Documents / Tickets',
                'DOCS': {
                    'TITULO': 'Last Documents',
                    'BOTON': 'Documents Management'
                },
                'TICKETS': {
                    'TITULO': 'Current Tickets',
                    'BOTON': 'Issue Tracker'
                },
                'ESTADO': 'Ticket Status'
            },
            'WIDGET2': {
                'TITULO': 'Location'
            },
            'WIDGET3': {
                'TITULO': 'Dashboards'
            },
            'WIDGET4': {
                'TITULO': '3D Viewer'
            },
            'STATS': {
                'USO': 'Usage',
                'TIPOLOGIA': 'Tipology',
                'PROPIETARIO': 'Owner',
                'NODESC': 'No description provided.',
                'REPORTING': 'Reporting plans',
                'BUILT': 'Doc. as built',
            }
        },
        'ACTIVOS': {
            'TABLA': {
                'CODIGO': 'Code',
                'NOMBRE': 'Name',
                'LOCALIZACION': 'Location',
                'ESTADO': 'Project Phase',
                'TIPOLOGIA': 'Project Tipology'
            },
            'LISTADO': {
                'TITULO': 'Assets Management',
                'BTN-CARGA': 'Assets upload',
                'ADDACTIVO': 'Add Asset',
                'ADDKPI': 'Add KPI',
                'ADDPOWERBI': 'Add PowerBI'
            },
            'DETALLE': {
                'TITULO': 'Asset Detail',
                'CODIGO': 'Code',
                'NOMBRE': 'Name',
                'CIUDAD': 'Location',
                'DIRECCION': 'Address',
                'ENLACE': 'Link 3D Viewer',
                'SECTOR': 'Project Sector',
                'ESTADO': 'Project Phase',
                'TIPOLOGIA': 'Project Tipology',
                'LATITUD': 'Latitude',
                'LONGITUD': 'Longitude',
                'SOCIEDAD': 'Owner company',
                'DESCRIPCION': 'Description',
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Edit Asset',
                'CREAR_TITULO': 'New Asset',
                'CODIGO': 'Code',
                'NOMBRE': 'Name',
                'CIUDAD': 'Location',
                'DIRECCION': 'Address',
                'ENLACE': 'Link 3D Viewer',
                'SECTOR': 'Project Sector',
                'ESTADO': 'Project Phase',
                'TIPOLOGIA': 'Project Tipology',
                'LATITUD': 'Latitude',
                'LONGITUD': 'Longitude',
                'CLIENTE': 'Client',
                'GUARDAR': 'Save',
                'FOTO': 'EDIT IMAGE',
                'CANCELAR': 'CANCEL',
                'SOCIEDAD': 'Owner company',
                'DESCRIPCION': 'Description',
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Delete Asset',
                'FOTOGRANDE': 'The file exceeds the maximum size of 2MB',
                'MENSAJEBORRAR': 'Are you sure to delete the selected asset?',
                'SINACTIVOS': 'No data from any assets',
                'ACTIVOBORRADO': 'The asset has been deleted correctly',
                'ACTIVONOBORRADO': 'Asset cannot be deleted. Please, try again later',
                'ACTIVONOOBTENIDO': 'Asset cannot be obtained. Please, try again later',
                'ACTIVOCREADO': 'Asset has been created correctly',
                'ACTIVONOCREADO': 'Asset cannot be created. Please, try again later',
                'ACTIVOEDITADO': 'Asset has been edited correctly',
                'ACTIVONOEDITADO': 'Asset cannot be edited. Please, try again later',
                'KPIS': {
                    'TITULOBORRAR': 'Delete KPI',
                    'MENSAJEBORRAR': 'Are you sure to delete the selected KPI?',
                    'KPIBORRADO': 'KPI has been deleted correctly',
                    'KPINOBORRADO': 'KPI cannot be deleted. Please, try again later'
                },
                'SECTORES': {
                    'NOOBTENIDOS': 'Sectors data cannot be recovered'
                },
                'SOCIEDADES': {
                    'NOOBTENIDOS': 'Owner companies data cannot be recovered'
                },
                'TIPOLOGIAS': {
                    'NOOBTENIDAS': 'Tipology data cannot be recovered'
                },
                'ESTADOSPROYECTO': {
                    'NOOBTENIDOS': 'Available Project Status cannot be recovered'
                },
                'CLIENTES': {
                    'NOOBTENIDOS': 'Asset cannot be assigned to a client due to lack of data'
                },
                'POWERBI': {
                    'TITULOBORRAR': 'Delete PowerBI',
                    'MENSAJEBORRAR': 'Are you sure to delete the selected PowerBI?',
                    'BORRADO': 'PowerBI has been deleted correctly',
                    'NOBORRADO': 'PowerBIcannot be deleted. Please, try again later',
                    'NOENCONTRADO': 'PowerBI report ID not found. Please, make sure the report ID is correct'
                },
                '3DVIEWER': {
                    'NOENLACE': 'There no related link for this asset'
                },
                'MODELBUILT': {
                    'NOENLACE': 'There no related link for this asset'
                },
                'CARGAEXCEL': {
                    'OKSUBIDO': 'Assets have been uploaded correctly',
                    'ERRORSUBIDA': 'Assets cannot be updloaded. Please, try again later'
                }
            }
        },
        'SOCIEDADES': {
            'TABLA': {
                'NOMBRE': 'Name',
            },
            'LISTADO': {
                'TITULO': 'Societies Management',
                'ADDSOCIEDAD': 'Add society',
            },
            'DETALLE': {
                'TITULO': 'Society detail',
                'NOMBRE': 'Name',
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Edit Society',
                'CREAR_TITULO': 'Edit Society',
                'NOMBRE': 'Name',
                'GUARDAR': 'Save',
                'CANCELAR': 'Cancel'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Delete society',
                'MENSAJEBORRAR': 'Are you sure to remove the selected society?',
                'SINSOCIEDADES': 'There is no societies data',
                'SOCIEDADBORRADO': 'Society removed successfully',
                'SOCIEDADNOBORRADO': 'Society could not be retrieved. Please try later',
                'SOCIEDADNOOBTENIDO': 'Society could not be retrieved. Please try later',
                'SOCIEDADCREADO': 'Society created successfully',
                'SOCIEDADNOCREADO': 'Society could not been created. Please, try later',
                'SOCIEDADEDITADO': 'Society updated successfully',
                'SOCIEDADNOEDITADO': 'Society could not been updated. Please, try later',
            }
        },
        'TICKETS': {
            'TABLA': {
                'TITULO': 'Title',
                'PRIORIDAD': 'Priority',
                'SOLICITANTE': 'Applicant',
                'ESTADO': 'Status',
                'ASIGNADO': 'Assigned',
                'ACTIVO': 'Active',
                'ASOCIADO': 'Associate document',
                'DOCUMENTO': 'Download associate document',
                'FECHA': 'Date of creation'
            },
            'LISTADO': {
                'TITULO': 'Issue Tracker',
                'AGREGAR': 'Add Ticket'
            },
            'DETALLE': {
                'TITULO': 'Ticket Detail',
                'TITULOTICKET': 'Ticket',
                'ESTADO': {
                    'NOMBRE': 'Status',
                    'ABIERTA': 'Opened',
                    'PROCESANDO': 'In process',
                    'CERRADA': 'Closed'
                },
                'SOLICITANTE': 'Applicant',
                'ACTIVO': 'Asset',
                'DESCRIPCION': 'Description',
                'PRIORIDAD': {
                    'NOMBRE': 'Priority',
                    'ALTA': 'High',
                    'MEDIA': 'Medium',
                    'BAJA': 'Low'
                },
                'ASIGNADO': 'Assigned',
                'OBSERVACIONES': 'Remarks'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Edit Ticket',
                'CREAR_TITULO': 'New Ticket',
                'TITULOTICKET': 'Ticket Title',
                'ESTADO': {
                    'NOMBRE': 'Status',
                    'ABIERTA': 'Opened',
                    'PROCESANDO': 'In process',
                    'CERRADA': 'Closed'
                },
                'SOLICITANTE': 'Applicant',
                'ACTIVO': 'Asset',
                'DESCRIPCION': 'Description',
                'PRIORIDAD': {
                    'NOMBRE': 'Priority',
                    'ALTA': 'High',
                    'MEDIA': 'Medium',
                    'BAJA': 'Low'
                },
                'ASIGNADO': 'Assigned',
                'OBSERVACIONES': 'Remarks',
                'GUARDAR': 'SAVE',
                'CANCELAR': 'CANCEL',
                'ADD-ANEXO': 'Add attachment',
                'AVISOANEXO': 'To add attachments, you must first create the ticket'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Delete Ticket',
                'MENSAJEBORRAR': 'Are you sure to delete the selected ticket?',
                'SINTICKETSDEACTIVO': 'No ticket data from this assets',
                'SINTICKETS': 'No ticket data from this assets',
                'TICKETBORRADO': 'The asset has been deleted correctly',
                'TICKETNOBORRADO': 'Ticket cannot be deleted. Please, try again later',
                'TICKETNOOBTENIDO': 'Ticket cannot be obtained. Please, try again later',
                'TICKETCREADO': 'Ticket has been created correctly',
                'TICKETNOCREADO': 'Ticket cannot be created. Please, try again later',
                'TICKETEDITADO': 'Ticket has been edited correctly',
                'TICKETNOEDITADO': 'Ticket cannot be edited. Please, try again later',
                'SINDOCUMENTO': 'No document associated to the ticket',
                'ELEGIRDOCUMENTO': 'Warning! Document has to be selected before generating the ticket',
                'USUARIOS': {
                    'SINUSUARIOS': 'Data cannot be recovered from any user. If you want to assign the ticket to someone, try again later'
                },
                'ACTIVOS': {
                    'SINACTIVOS': 'Data cannot be recovered from any asset. If you want to assign the ticket to some asset, try again later'
                },
                'NOPUEDEVERANEXO': 'Ticket must be generated before adding attachments',
                'ANEXOADDED': 'Attachment added'
            },
            'ANEXOS': 'Attachments'
        },
        'CLIENTES': {
            'LISTADO': {
                'TITULO': 'Clients Management'
            },
            'DETALLE': {
                'TITULO': 'Client Detail'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Edit Client',
                'CREAR_TITULO': 'New Client',
                'GUARDAR': 'SAVE',
                'CANCELAR': 'CANCEL',
                'EDITARLOGO' : 'EDIT LOGO',
                'ADDCLIENTE': 'Add Client'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Delete Client',
                'MENSAJEBORRAR': 'Are you sure to delete the selected client?',
                'SINCLIENTES': 'No data can be obtained from any client',
                'CLIENTEBORRADO': 'Client has been deleted correctly',
                'CLIENTENOBORRADO': 'Client cannot be deleted. Please, try again later',
                'CLIENTENOOBTENIDO': 'Client cannot be obtained. Please, try again later',
                'CLIENTECREADO': 'Client has been created correctly',
                'CLIENTENOCREADO': 'Client cannot be created. Please, try again later',
                'CLIENTEEDITADO': 'Client has been edited correctly',
                'CLIENTENOEDITADO': 'Client cannot be edited. Please, try again later'
            },
            'CAMPOS': {
                'NOMBRE': 'Name',
                'CODIGO': 'Code',
                'USUARIOAWS': 'AWS User',
                'PASSAWS': 'AWS Password',
                'BUCKETAWS': 'AWS Bucket',
                'USUARIOSCREADOS': 'Users created',
                'MAXUSUARIOS': 'Max. users',
                'ACTIVOS': 'Assets',
                'MAXACTIVOS': 'Max. assets',
                'POWERBIDASHBOARD': 'General Dashboard PowerBI ID',
                'HIDEFILTERS': 'Hide specific filters',
            }
        },
        'USUARIOS': {
            'LISTADO': {
                'TITULO': 'Users Management',
                'NOMBRE': 'Name',
                'APELLIDOS': 'Last Name',
                'CLIENTE': 'Client',
                'ACCIONES': 'Actions',
                'ROL': 'Role',
                'USUARIOSRESTANTES': 'Remaining users',
                'ADDUSUARIO': 'Add User',
                'HIDDENASSETS': 'Hidden assets'
            },
            'DETALLE': {
                'TITULO': 'User Detail'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Edit User',
                'CREAR_TITULO': 'New User',
                'GUARDAR': 'SAVE',
                'CANCELAR': 'CANCEL',
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Delete User',
                'MENSAJEBORRAR': 'Are you sure to delete the selected client?',
                'SINUSUARIOS': 'No data can be obtained from any user',
                'USUARIOBORRADO': 'User has been deleted correctly',
                'USUARIONOBORRADO': 'User cannot be deleted. Please, try again later',
                'USUARIONOOBTENIDO': 'User cannot be obtained. Please, try again later',
                'USUARIOCREADO': 'User has been created correctly',
                'USUARIONOCREADO': 'User cannot be created. Please, try again later',
                'USUARIOEDITADO': 'User has been created correctly',
                'USUARIONOEDITADO': 'User cannot be edited. Please, try again later',
                'ROLES': {
                    'SINROLES': 'An error occurred and we were unable to get the roles. Please, try again later'
                },
                'CLIENTES': {
                    'NOOBTENIDOS': 'Unable to assign user to a client due to no data can be obtained from any client'
                },
                'ACTIVOSOCULTOS': {
                    'SINACTIVOS': 'An error occurred and we were unable to get the hidden assets. Please, try again later'
                },
            }
        },
        'FILEMANAGER': {
            'LISTADO': {
                'TITULO': 'Documents Management',
                'CLIENTE': 'Select client',
                'BUSCAR': 'Search File',
                'CARPETA': 'New Folder',
                'SUBIR': 'Upload File',
                'NOMBRE': 'Name',
                'VERSION': 'Version',
                'SIZE': 'Size',
                'MODIFICACION': 'Last change',
                'SUBIR_VERSION': 'New version',
                'TICKET': 'Generate ticket for this document',
                'QR': 'Print Pdf with QR code',
                'PREVIEW': 'Preview',
                'GEN-TICKET': 'Generate ticket',
                'COPY': 'Copy',
                'ASOCIADO': 'Associate Asset',
                'PRINT-QR': 'Print with QR',
                'ROOT_FOLDER': 'Project Folder',
                'ASOCIAR_TICKET': 'Associate to a ticket',
                'ASOCIAR_ACTIVO': 'Associate to an asset',
            },
            'CLIENTENOESTABLECIDO': 'Warning! Client has to be selected before checking the associate documentation',
            'SINRESULTADOS': 'Searching has not obtained any results',
            'NOMBREINCORRECTO': 'The name cannot contain the symbol "/"',
            'INICIOCOPIA': 'File copied to the clipboard. Find the correct folder and press the option "COPY HERE"',
            'COPIAR': 'COPIAR AQUÍ',
            'COPIAENRAIZNOPERMITIDA': 'File cannot be copied on this root',
            'COPIAENMISMACARPETA': 'File cannot be copied in origin folder',
            'BORRARCARPETA': {
                'TITULO': 'Warning!',
                'MENSAJE': 'Are you sure to delete the folder and contents?'
            },
            'BORRARARCHIVO': {
                'TITULO': 'Delete File',
                'MENSAJE': 'Are you sure to delete the selected file?'
            },
            'ACTIVO': {
                'ASOCIADO': 'Associate Asset'
            },
            'ACTIVOCARPETANOTFOUND': 'Asset associated to the current folder cannot be obtained',
            'SUBIDAVERSION': 'Version uploaded correctly',
            'SUBIRARCHIVOEXISTENTE': {
                'TITULO': 'Warning!',
                'MENSAJE': 'File already exists. Upload new version?'
            },
        },
        'GENERAL-DASHBOARD': {
            'TITULO': 'General Dashboard'
        },
        'POWER-BI': {
            'TITULO': 'Power BI'
        },
        '3D-VIEWER': {
            'TITULO': '3D Viewer'
        },
        'MYPROFILE': {
            'TITULO' : 'My Profile',
            'CAMBIARPASS': 'Change password',
            'PASS1': 'New password',
            'PASS2': 'Repeat password',
            'MENSAJES': {
                'PASSACTUALIZADA': 'Password correctly updated',
                'PASSIGUAL': 'Password matches the previous one',
                'PASSRESETEADA': 'An email with the new password has been sent',
                'PASSNORESETEADA': 'Password cannot be reset, please try again later',
                'FORMULARIOENVIADO': 'Your message has been sent',
                'FORMULARIONOENVIADO': 'Your message couldn\'t been sent. Please, try again later',
            },
            'ACTUALIZAR': 'Update Data',
        },
        'ACCIONES': 'Actions',
        'BUSCAR': 'Search...',
        'ITEMSXPAGINA': 'Results per page',
        'SESIONEXPIRADA': 'Expired session',
        'NOAUTORIZADO': 'Not authorised',
        'ERRORCONEXION': 'Conection error. Please, try again later',
        'ERRORDESCONOCIDO': 'Unknown error. Please, try again later',
        'LOGIN': {
            'CREDENCIALESINVALIDAS': 'Invalid User or password',
            'USUARIO': 'User',
            'PASS': 'Password',
            'RECORDAR': 'Remember me',
            'OLVIDADA': 'Forgot Password?',
            'ACCEDER': 'ENTER'
        },
        'TIPOFOTO': 'Please upload a JPG or PNG image type',
        'TIPOEXCEL': 'Upload xls file',
        'ACEPTAR': 'Accept',
        'CANCELAR': 'Cancel',
        'DESCARGAR': 'Download',
        'BORRAR': 'Delete',
        'DETALLE' : 'Detail',
        'EDITAR': 'Edit',
        'LISTA_TICKETS': 'Tickets list',
        'SELECCIONAR': 'Select',
        'VER-EDITAR': 'Detail / Edit',
        'ENVIAR': 'Send',
        'TOOLBAR': {
            'CONTACTO': {
                'TITULO': 'Contact form',
                'PROBLEMA': 'Issue',
                'DESCRIPCION': 'Description'
            }
        },
        'MAPA': {
            'POPUP': {
                'TIPOLOGIA': 'Project Tipology',
                'LOCALIZACION': 'Location',
            }
        },
        'FORGOT': {
            'RECUPERAR': 'SEND NEW PASSWORD',
            'RESET': 'RESET PASSWORD',
            'VOLVER': 'Return to login'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/i18n/en.ts